import { render, staticRenderFns } from "./Reyting.vue?vue&type=template&id=71ce372f&scoped=true"
import script from "./Reyting.vue?vue&type=script&lang=js"
export * from "./Reyting.vue?vue&type=script&lang=js"
import style0 from "./Reyting.vue?vue&type=style&index=0&id=71ce372f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce372f",
  null
  
)

export default component.exports